import React, { useState } from "react";
import { X } from "@phosphor-icons/react";

/**
 * Shows a small banner only when visitors land on the backup
 * `*.emergent.host` URL, pointing them to the official `mpsound.eu` site.
 * Helps consolidate SEO and brand visibility to the canonical domain.
 * Dismissible — remembered per browser via localStorage.
 */
const OFFICIAL_HOST = "mpsound.eu";
const DISMISS_KEY = "mp_official_banner_dismissed_v1";

export default function FallbackBanner() {
  const [show, setShow] = useState(() => {
    if (typeof window === "undefined") return false;
    const host = window.location.hostname;
    const dismissed = (() => { try { return localStorage.getItem(DISMISS_KEY) === "1"; } catch (_e) { return false; } })();
    return !dismissed && host.endsWith(".emergent.host");
  });

  const dismiss = () => {
    try { localStorage.setItem(DISMISS_KEY, "1"); } catch (_e) { /* ignore */ }
    setShow(false);
  };

  if (!show) return null;

  const officialUrl = `https://${OFFICIAL_HOST}${window.location.pathname}${window.location.search}`;

  return (
    <div
      data-testid="fallback-banner"
      className="w-full bg-[#d4ff00] text-black text-xs sm:text-sm mono-font uppercase tracking-wider px-4 sm:px-6 py-2 flex items-center justify-center gap-3 relative"
      style={{ letterSpacing: "0.08em" }}
    >
      <span className="hidden sm:inline">You&apos;re on our backup URL.</span>
      <a
        href={officialUrl}
        className="underline font-bold hover:no-underline whitespace-nowrap"
        data-testid="official-site-link"
      >
        Visit official site → mpsound.eu
      </a>
      <button
        onClick={dismiss}
        aria-label="Dismiss"
        className="absolute right-3 top-1/2 -translate-y-1/2 p-1 hover:opacity-70"
        data-testid="fallback-banner-dismiss"
      >
        <X size={14} weight="bold" />
      </button>
    </div>
  );
}
